import { memo } from 'react'

const PriceDisplay = ({ price, period }) => {
  const formatter = new Intl.NumberFormat('pt-BR', {
    style: 'currency',
    currency: 'BRL',
    minimumFractionDigits: 2,
  })

  const [whole, decimal = '00'] = formatter.format(price).split(',')

  return (
    <div className="inline-block whitespace-nowrap text-3xl font-semibold">
      <span className="align-baselin">{whole.replace('R$', 'R$ ')}</span>
      <span className="align-super text-sm">
        ,{decimal}/{period}
      </span>
    </div>
  )
}

export default memo(PriceDisplay)
